//import ArchiveIcon from '@mui/icons-material/Archive';
//import EditIcon from '@mui/icons-material/Edit';
//import FileCopyIcon from '@mui/icons-material/FileCopy';
//import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
//import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
//import { Button } from '@mui/material';
//import Divider from '@mui/material/Divider';
import {IconButton } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
//import { MenuProps }  from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';
//import {useState } from 'react';
//import { NavDropdown } from 'react-bootstrap';
// import styles from './Counter.module.css';
import { useTranslation } from 'react-i18next';
import { useDispatch} from 'react-redux';
import {useSelector} from 'react-redux';

import { EngIcon, FrIcon } from '../../data/SVGs';
//import {FrIcon,EngIcon} from '../../data/SVGs';
import {
    // incrementByAmount,
    // incrementAsync,
    selectLang,
    setLang2Eng,
    //setLang2Eng,
    setLang2Fr,
} from './langueSlice';

export function Langue() {

    const lang = useSelector(selectLang);
    //const lang= useState('fr');
    const dispatch = useDispatch();
    // const [incrementAmount, setIncrementAmount] = useState('2');

    // ! multiLanguages
    const { i18n } = useTranslation();
    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
        // lang here is the inverse of current lang en <==> fr
        console.log(lang);
    };
    const [anchorEl, setAnchorEl] = useState(false);

    const handleCloseMenu=()=>{
        setAnchorEl(false);
        //  setAnchorEl(null);
    };
    const handleClick = () => {
        setAnchorEl(false);
        if(lang == 'fr'){
            changeLanguage('en');
            dispatch(setLang2Eng());
        }
        else{
            changeLanguage('fr');
            dispatch(setLang2Fr());
        }
    };

    return (
        <>
            {/*<NavDropdown
                title={i18n.language} //!I won't select it from the browser or the i18nxt preferences
                id="nav-dropdown"
            >
                <NavDropdown.Item
                    eventKey="4.3"
                    style={{ backgroundColor: lang == 'en' ? null : 'grey' }}
                >
                    <img
                        src={FrIcon}
                        alt="Fr"
                        onClick={() => {
                            changeLanguage('fr');
                            dispatch(setLang2Fr());
                            // !reducer with Arg: dispatch(incrementByAmount(Number(incrementAmount) || 0),
                            //  and you will recieve it in an action.payload  as second arg ,
                            // the first will be the state as alwaus
                        }}
                    />
                <NavDropdown.Divider />
                <NavDropdown.Item
                    eventKey="4.4"
                    style={{ backgroundColor: lang == 'fr' ? null : 'grey' }}
                >
                    //<Button
                    //    variant='text'
                    //>
                    <img
                        src={EngIcon}
                        alt="Eng"
                        onClick={() => {
                            changeLanguage('en');
                            dispatch(setLang2Eng());
                        }
                        }
                    />
                    //</Button>
                </NavDropdown.Item>
            </NavDropdown>*/}

            <IconButton
                onClick={()=>{
                    setAnchorEl(true);
                }}
            >
                {lang=='en' ?<EngIcon /> : <FrIcon />}
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                sx={{ mt: '80px' ,ml:'-180px'}}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                //keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
            >
                <MenuItem
                    onClick={handleClick}
                >
                    <ListItemIcon>
                        {lang=='fr' ?
                            <EngIcon />
                            :
                            <FrIcon />
                        }
                    </ListItemIcon>
                    {lang=='fr' ?
                        'Anglais'
                        :
                        'French' //'français'
                    }
                </MenuItem>
            </Menu>
        </>
    );
}
{/*<img
                    src={lang=='en' ? 'a' : <FrIcon />}
                    //aria-expanded={open ? 'true' : undefined}
                    //onClick={
                    //        handleClick();
                    //        changeLanguage('fr');
                    //}
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    //onClick={() => {
                    //    handleClickOpen();
                    //    changeLanguage('fr');
                    //    dispatch(setLang2Fr());
                    //}}
                />*/}

/**
 * ? OLD FILE
 * // import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { Button, List, ListItem, ListSubheader, Popover } from '@mui/material';
import i18next from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';

const languageMap = {
    en: { label: 'English', dir: 'ltr', active: true },
    ar: { label: 'العربية', dir: 'rtl', active: false },
    fr: { label: 'Français', dir: 'ltr', active: false }
};

const LanguageSelect = () => {
    const selected = localStorage.getItem('i18nextLng') || 'en';
    const { t } = useTranslation();

    const [menuAnchor, setMenuAnchor] = React.useState(null);
    React.useEffect(() => {
        document.body.dir = languageMap[selected].dir;
    }, [menuAnchor, selected]);

    return (
        <div className="d-flex justify-content-end align-items-center language-select-root">
            <Button onClick={({ currentTarget }) => setMenuAnchor(currentTarget)}>
                {languageMap[selected].label}
                </Button>
                <Popover
                    open={!!menuAnchor}
                    anchorEl={menuAnchor}
                    onClose={() => setMenuAnchor(null)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                >
                    <div>
                        <List>
                            <ListSubheader>{t('select_language')}</ListSubheader>
                            {Object.keys(languageMap || {})?.map(item => (
                                <ListItem
                                    button
                                    key={item}
                                    onClick={() => {
                                        i18next.changeLanguage(item);
                                        setMenuAnchor(null);
                                    }}
                                >
                                    {languageMap[item].label}
                                </ListItem>
                            ))}
                        </List>
                    </div>
                </Popover>
            </div>
        );
    };

    export default LanguageSelect;

 */